import IdentityPageLayout from '@/features/identity/components/IdentityPageLayout.tsx';
import useMediaQuery from '@/hooks/useMediaQuery';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import OwnInnIcon from '@/components/icons/OwnInnIcon';
import { AppConfig } from '@/config/app.config';

const SignUpConfirmPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

    return (
        <IdentityPageLayout>
            <div
                className={cn(
                    'my-auto flex-1 flex flex-col gap-6 rounded-2.5xl bg-popover-10',
                    isMobile ? 'grow' : 'max-w-[20.5rem]',
                )}
            >
                <div className="flex flex-col items-center gap-4 text-center">
                    <OwnInnIcon className="size-11" />
                    <div className="w-[20.5rem] flex flex-col items-center gap-2">
                        <h3 className="text-2xl font-semibold select-none">
                            {t('auth.signupConfirmForm.email.message')}
                        </h3>
                        <p className="text-sm text-popover-800 font-medium">
                            {t('auth.signupConfirmForm.email.description')}
                        </p>
                        <div className="flex justify-center gap-1.5">
                            <p className="text-sm text-popover-800 font-medium">
                                {t('elements.buttons.goBack')}
                            </p>
                            <Button
                                onClick={() => navigate('/auth/login')}
                                type="button"
                                variant="link"
                                className="p-0 hover:text-popover-800 active:text-popover-600"
                            >
                                {t('elements.buttons.login')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </IdentityPageLayout>
    );
};

export default SignUpConfirmPage;
